module.exports = "<div ui-view=\"embedded-base-content\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/embedded/embedded-base-page.html
// module id = 1128
// module chunks = 0